import { CountryRiskView } from '@grid-ui/common';
import { ItemInformationListingItemDatatype } from '../item-information-listing';

export function isCountryRiskView(data: ItemInformationListingItemDatatype): data is CountryRiskView {
  return (data as CountryRiskView).creator !== undefined;
}
